import { WidgetRecFlowScreen, WidgetQuestionField, WidgetQuestionFields, WidgetQuestionInfo } from '@/types'

export * from './chat-enabled'
export * from './contactIdentity'
export * from './device'
export * from './ids'
export * from './effects'
export * from './format'
export * from './getValue'
export * from './kiosk'
export * from './logger'
export * from './storage'
export * from './styles'
export * from './toaster'

export const isLocal = () => {
  const host = window.location.hostname
  return host === 'localhost' || host === '127.0.0.1'
}
export const isStaging = () => window.location.hostname.includes('aiqstaging')

export const utils = {
  isLocal,
  isStaging,
}

export const isEmptyValue = (value: any) => {
  return value === undefined || value === null || value === ''
}

export const getDefaultRecFlowQuestionScreenSettings = (): Record<string, WidgetRecFlowScreen> => {
  const fields = Object.entries(WidgetQuestionFields) as [WidgetQuestionField, WidgetQuestionInfo][]
  const questions: Record<string, WidgetRecFlowScreen> = {}

  fields.forEach(([field, metaData]) => {
    const fieldKey = field.toString().replace(/([A-Z])/g, (match) => match.toLowerCase())
    questions[fieldKey] = {
      enabled: metaData.enabled ?? false,
      required: metaData.required ?? false,
      priority: metaData.defaultPriority ?? 0,
    }
  })

  return questions
}

export const isEdiblesCategory = (category: string) => {
  return category.toLowerCase().trim() === 'edibles'
}
